<template>
  <div class="main">
    <!-- 人身险保单 -->
    <div class="tab-box">
      <Tabs v-model="isAbnormal" class="tabs" :animated="false" @on-click="toggleTab">
        <TabPane label="普通单" name="0"></TabPane>
        <TabPane label="异常单" name="1"></TabPane>
        <Poptip trigger="hover" placement="bottom-start" class="tabPop" transfer>
          <Icon type="ios-help-circle-outline" size="18" color="#000" style="margin-left: -6px; margin-top: 2px" />
          <div slot="content" style="color: #333">
            有问题的保单（如信息不全）。异常单无法统计业绩、无法结算、无法生成续期记录，请在需要的时候及时转存为普通单。
          </div>
        </Poptip>
      </Tabs>
      <div class="tools-box">
        <Button type="primary" class="draft-btn" ghost @click="$router.push('/orderManage/insuredOrder/draftList')">
          <Icon type="md-clipboard" />
          草稿箱
          <span class="num-box" v-if="draftCount">{{ draftCount }}</span>
        </Button>
        <Button type="warning" @click="modifyPolicy('add', '')" v-if="$units.pointAction('order_30_2') && userInfo.userType != 4">新增</Button>

        <Dropdown
          :transfer="true"
          style="margin-left: 10px"
          @on-click="dropdownClick($event)"
          v-if="isAbnormal == '0' && ($units.pointAction('order_30_3') || $units.pointAction('order_30_18'))"
        >
          <Button type="primary" ghost>批量导入 <Icon type="ios-arrow-down"></Icon></Button>
          <template #list>
            <DropdownMenu>
              <DropdownItem v-if="$units.pointAction('order_30_3')" name="importModal">批量导入保单</DropdownItem>
              <DropdownItem v-if="userInfo.levelCode == '10001' && $units.pointAction('order_30_18')" name="batchImportCommission"
                >批量导入费用</DropdownItem
              >
            </DropdownMenu>
            <!-- <div class="item" v-if="$units.pointAction('order_30_3')" @click="importModal">批量导入保单</div>
            <div class="item" @click="batchImportCommission" v-if="userInfo.levelCode == '10001' && $units.pointAction('order_30_18')">批量导入费用</div> -->
          </template>
        </Dropdown>
        <Button v-if="isAbnormal == '1' && $units.pointAction('order_30_3')" type="primary" ghost @click="importModal">导入</Button>

        <Dropdown
          :transfer="true"
          @on-click="dropdownClick($event)"
          style="margin-left: 10px"
          v-if="isAbnormal == '0' && ($units.pointAction('order_30_15') || $units.pointAction('order_30_14'))"
        >
          <Button type="primary" ghost>批量更新<Icon type="ios-arrow-down"></Icon></Button>
          <template #list>
            <DropdownMenu>
              <DropdownItem name="changeBaseMassege" v-if="$units.pointAction('order_30_15')">批量更新基本信息</DropdownItem>
              <DropdownItem name="changeStatus" v-if="$units.pointAction('order_30_14')">批量更新保单状态</DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
      </div>
    </div>
    <keep-alive>
      <order ref="order" v-if="isAbnormal === '0'" :show="isAbnormal === '0'"></order>
      <anomalyOrder ref="anomalyOrder" v-if="isAbnormal === '1'" :show="isAbnormal === '1'"></anomalyOrder>
    </keep-alive>
    <updatePolicyModal ref="updatePolicyModal" @getParams="getParams" :initFilterObj="initFilterObj" @toggleTab="toggleTab"></updatePolicyModal>
    <updateBaseMassegeModal ref="updateBaseMassegeModal" @getParams="getParams" :initFilterObj="initFilterObj" @toggleTab="toggleTab"></updateBaseMassegeModal>
    <import-commission ref="importCommissionRef" @success="getParams"></import-commission>
  </div>
</template>
  
<script>
import { common } from '@/api/mixins';
import order from './order.vue';
import { mapState } from 'vuex';
import anomalyOrder from './anomalyOrder.vue';
import updatePolicyModal from './components/updatePolicyModal.vue';
import updateBaseMassegeModal from './components/updateBaseMassegeModal.vue';
import importCommission from './components/importCommission.vue';
export default {
  mixins: [common],
  computed: {
    ...mapState(['userInfo'])
  },
  components: { order, anomalyOrder, updatePolicyModal, updateBaseMassegeModal, importCommission },
  data() {
    return {
      isAbnormal: '0',
      draftCount: 0,
      initFilterObj: {}
    };
  },
  activated() {
    if (this.$route.query.isAbnormal) {
      this.isAbnormal = this.$route.query.isAbnormal;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    this.getDraftCount();
  },
  methods: {
    getParams() {
      if (this.isAbnormal === '0') {
        this.initFilterObj = this.$refs.order.initFilterObj();
      } else if (this.isAbnormal === '1') {
        this.initFilterObj = this.$refs.anomalyOrder.initFilterObj();
      }
    },
    // 更多操作
    dropdownClick(name) {
      if (name == 'changeStatus') {
        this.$refs.updatePolicyModal.open();
      } else if (name == 'changeBaseMassege') {
        this.$refs.updateBaseMassegeModal.open();
      } else if (name == 'importModal') {
        this.importModal()
      } else if (name == 'batchImportCommission') {
        this.batchImportCommission();
      }
    },
    toggleTab() {
      // if (this.isAbnormal === '0') {
      //   this.$refs.order.getList();
      //   this.$refs.order.getImport();
      // } else {
      //   this.$refs.anomalyOrder.getList();
      //   this.$refs.anomalyOrder.getImport();
      // }
    },
    // 获取草稿箱数量
    getDraftCount() {
      this.$http({
        url: '/buz/policyDraft/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 1
        }
      }).then(res => {
        this.draftCount = res.total;
      });
    },
    // 批量导入保单
    importModal() {
      if (this.isAbnormal == '0') {
        this.$refs.order.importModal();
      } else {
        this.$refs.anomalyOrder.importModal();
      }
    },
    // 批量导入费用
    batchImportCommission() {
      let dic = JSON.parse(localStorage.dic)['COMMISSION_LOG_IMPORT'];
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importCommissionRef.open({
        params: {},
        template: key,
        templateName: dic[key],
        uploadUrl: '/buz/commissionLog/upload/repairLogs',
        errorUrl: '/buz/commissionLog/exportError'
      });
    },
    // 新增
    modifyPolicy(flag, row) {
      if (flag == 'add') {
        sessionStorage.reloadPolicyData = '1';
        this.$router.push({
          path: '/orderManage/insuredOrder/addPolicy',
          query: { pageFlag: flag, timeStr: new Date().getTime() }
        });
      } else if (flag == 'edit') {
        this.openPageTabTags('/orderManage/insuredOrder/editPolicy/' + row.policyNo, {
          pageFlag: 'edit',
          pageName: 'policyManage',
          id: row.id,
          policyNo: row.policyNo
        });
      } else if (flag == 'delete') {
        this.$Modal.confirm({
          title: '删除',
          content: '<p>确认删除操作?</p>',
          loading: true,
          onOk: () => {
            delEnterPolicy({ policyNo: row.policyNo })
              .then(res => {
                this.searchParams.pageNo = 1;
                this.getInsureList();
                this.$Modal.remove();
                this.$Message.success('删除成功');
              })
              .catch(err => {
                this.$Modal.remove();
              });
          }
        });
      }
    }
  }
};
</script>
  
<style lang="scss" scoped>
.main {
  min-width: 1200px;
  .tabs {
    border-left: 10px solid #f5f7f9;
    padding-left: 20px;
  }

  .draft-btn {
    position: relative;
    background: #f4f7ff;
    color: #236dff;
    border: 0;

    .num-box {
      position: absolute;
      right: -7px;
      top: -7px;
      height: 15px;
      min-width: 15px;
      padding: 0 3px;
      line-height: 20px;
      background-color: red;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
    }
  }

  .tab-box {
    position: relative;
    min-height: 40px;
    .tabPop {
      position: absolute;
      left: 165px;
      top: 18px;
    }
    .tools-box {
      position: absolute;
      right: 20px;
      top: 10px;
      /deep/ .ivu-poptip-body {
        width: 100px;
        padding: 0;
      }
      /deep/ .ivu-poptip-inner {
        width: 100px;
      }
      .item {
        font-size: 13px;
        cursor: pointer;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item:last-child {
        border-top: 1px solid #dfdcdc;
      }
    }
  }

  /deep/ .ivu-tabs-bar {
    padding-top: 10px;
  }
}
</style>